import { IGif } from '@giphy/js-types'
import { AttributionOverlay, GifOverlayProps } from '@giphy/react-components'
import React, { createContext, ReactType, SyntheticEvent, useContext } from 'react'
import Media from 'react-media'
import { useKeyPress } from 'react-use'
import { desktop } from 'shared/util/media-query'
import ChannelPageContext from './context/channel-page'
import GifMenuOverlay, { LockOverlay } from './gif-menu-overlay'
import GifSelectionOverlay from './gif-selector-overaly'
import TagOverlay from './tag-overlay'

type GridOverlayContextProps = {
    onGifClick: (gif: IGif, e: SyntheticEvent<HTMLElement, Event>) => void
    selectedGifs: (number | string)[]
    iSelectionMode: boolean
    Overlay?: ReactType<GifOverlayProps>
}
export const GridOverlayContext = createContext({} as GridOverlayContextProps)

const DefaultOverlays = ({ gif, isHovered }: GifOverlayProps) => {
    const { channel } = useContext(ChannelPageContext)
    // if we're on a channel page, hide attribution if the gif user matches
    // the channel page user
    const hideAttribution = channel?.user?.id === gif.user?.id
    return (
        <Media
            query={desktop.query}
            render={() => (
                <>
                    <GifMenuOverlay gif={gif} isHovered={isHovered} />
                    {gif.user && !hideAttribution ? (
                        <AttributionOverlay gif={gif} isHovered={isHovered} />
                    ) : (
                        <TagOverlay gif={gif} isHovered={isHovered} />
                    )}
                </>
            )}
        />
    )
}

const GridOverlay = ({ gif, isHovered }: GifOverlayProps) => {
    const { onGifClick, selectedGifs, iSelectionMode, Overlay } = useContext(GridOverlayContext)
    const [isDetailMode] = useKeyPress((event: KeyboardEvent) => event.keyCode === 18)
    // these defaults will only render on desktop

    return iSelectionMode ? (
        <>
            <LockOverlay gif={gif} isHovered={isHovered} />
            <GifSelectionOverlay
                gif={gif}
                index={selectedGifs.indexOf(gif.id)}
                onClick={onGifClick}
                showDetails={isDetailMode}
            />
        </>
    ) : Overlay ? (
        <>
            <Overlay gif={gif} isHovered={isHovered} />
            <DefaultOverlays gif={gif} isHovered={isHovered} />
        </>
    ) : (
        <DefaultOverlays gif={gif} isHovered={isHovered} />
    )
}

export default GridOverlay
